module.exports = __webpack_public_path__ + "static/media/neoen.d827289e.png";